import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getExportReportOperators = async (queries = '') => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `attendance-report/operators/export?${queries}`, responseType: 'blob' });

  return data;
};

export default getExportReportOperators;
